const checkNull = (val, key) => (val === null ? "" : val[key]);

function getlocalstorage(localstorage, key) {
  return checkNull(JSON.parse(localstorage), key);
}

const ACCESSTOKEN =
  localStorage.getItem("access-token") === null
    ? ""
    : localStorage.getItem("access-token");

const COMPANY_ID = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "company_id"
);

const USER_ID = checkNull(JSON.parse(localStorage.getItem("profile")), "id");

const USERNAME = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "username"
);

const VUC = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "vehicle_visibility"
);

const PERMISSIONS = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "permissions"
);

const EMAIL = checkNull(JSON.parse(localStorage.getItem("profile")), "email");

const FIRSTNAME = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "firstname"
);

const LASTNAME = checkNull(
  JSON.parse(localStorage.getItem("profile")),
  "lastname"
);

// ภาษาของหน้าจอ (th / en) ที่เลือกจากเมนูโปรไฟล์ เก็บไว้ให้ reload แล้วยังเป็นภาษาเดิม (ค่าเริ่มต้น ไทย)
// อ่าน/เขียนใน try เพราะ browser บางแบบ (private mode, ปิด storage) โยน error ได้
const LANG_STORAGE_KEY = "lang";
const LANGUAGES = ["th", "en"];
const DEFAULT_LANG = "th";

function getStoredLang() {
  try {
    const lang = localStorage.getItem(LANG_STORAGE_KEY);
    return LANGUAGES.indexOf(lang) !== -1 ? lang : DEFAULT_LANG;
  } catch (e) {
    return DEFAULT_LANG;
  }
}

function storeLang(lang) {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch (e) {
    // เก็บไม่ได้ก็ยังสลับภาษาได้ แค่ reload แล้วกลับเป็นค่าเริ่มต้น
  }
}

export {
  LANG_STORAGE_KEY,
  LANGUAGES,
  DEFAULT_LANG,
  getStoredLang,
  storeLang,
  COMPANY_ID,
  USER_ID,
  USERNAME,
  VUC,
  EMAIL,
  FIRSTNAME,
  LASTNAME,
  PERMISSIONS,
  ACCESSTOKEN,
  getlocalstorage
};
